const footerLinks = {
    firstGroup: [
        {
            link: '/about/investors/regulatory-purp',
            title: 'Информация о&nbsp;максимальных процентных ставках по&nbsp;вкладам физических лиц',
        },
        {
            link: '/files/about/requisites.pdf',
            title: 'Реквизиты',
        },
        {
            link: '/nadzorniy_organ',
            title: 'Надзорный орган',
        },
        {
            link: 'https://e-disclosure.ru/portal/company.aspx?id=3018&attempt=3',
            title: 'Раскрытие информации на&nbsp;сайте&nbsp;ИА&nbsp;Интерфакс',
        },
        {
            link: 'https://zalog-market.ru/',
            title: 'Реализация имущества',
        },
        {
            link: '/presentation-information',
            title: `Уведомление физических лиц о&nbsp;необходимости представления сведений
            (документов) для&nbsp;целей исполнения законодательства о&nbsp;ПОД/ФТ`,
        },
    ],
    secondGroup: [
        {
            link: '/deposit-insurance',
            title: 'Страхование вкладов',
        },
        {
            link: '/files/about/statement-working-conditions.pdf',
            title: 'Оценка условий труда',
        },
    ],
    thirdGroup: [
        {
            link: '/images/about/license.jpg',
            title: 'Генеральная лицензия Банка России №&nbsp;2225&nbsp;от&nbsp;26&nbsp;августа&nbsp;2016&nbsp;г.',
        },
        {
            link: '/agreement',
            title: 'Соглашение об&nbsp;использовании информации на&nbsp;сайте',
        },
        {
            link: '/about/investors/pub-info',
            title: 'Раскрытие информации',
        },
        {
            link: '/about/investors/pub-info',
            title: 'Раскрытие информации профессионального участника рынка ценных бумаг',
        },
        {
            link: '/financial-commissioner',
            title: 'Финансовый уполномоченный',
        },
    ],
};

const footerPhones = [
    {
        title: 'Бесплатный звонок по России',
        phone: '8 800 200 99 29',
    },
    // {
    //     title: 'Для бизнеса',
    //     phone: '8 800 200 88 66',
    // },
    {
        title: 'Поддержка по картам и банкоматам',
        phone: '8 800 200 91 09',
    },
    {
        title: 'Для звонков из других стран',
        phone: '+7 863 200 00 00',
    },
];

export {
    footerLinks,
    footerPhones,
};
